module.exports = __webpack_public_path__ + "img/GME_120X35.4a864aec.png";